export default function (context, val) {
    let name = val;
    context.commit(name + '/set_filter');
    let setting = context.state[name];
    setting.filter = setting.filters[setting.filters.length - 1].id;
}